// extracted by mini-css-extract-plugin
export default {"container":"tq-z","brandName":"uq-z","productName":"vq-z","productNamePdpEnhancements":"wq-z","breakLongProductName":"xq-z"};